import { Injectable } from "@angular/core";
import { delay, Observable, of } from "rxjs";
import { BaseService } from 'app/_services/base.service';
import { SettingsService } from "app/_services/settings.service";
import { environment } from '../../../../environments/environment';
import { ApiResponseModelFactory } from 'app/_models/apiResponseModel';
import { QuotationPartTypeEnum } from 'app/_models/_enums/quotationPartType.enum';

@Injectable({ providedIn: 'root' })
export class DisputeDetailService extends BaseService {
    private _apiSupportUrl: string = `${environment.apiSupport}`;
    private _domain: string = '/disputes';

    constructor(private config: SettingsService) {
        super();
    }

    public getDisputeDetails(orderInfoId: string): Observable<any> {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${orderInfoId}/orders` });
    }
}
